import { createAsyncTypes } from '../Utilities'

export const GET_PROJECT_ASYNC = createAsyncTypes('GET_PROJECT')
